import React, { useEffect } from "react";
import { getTableData } from "./redux/longRunningDelayedJobsSaga";
import { useDispatch, useSelector } from "react-redux";

import EventLogsTable from "./smartComponents/EventLogsTable";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import "./longRunningDelayedJobs.scss";

export const LongRunningDelayedJobsModule = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.longRunningDelayedJobs);

  useEffect(() => {
    dispatch(getTableData());
  }, []);

  return (
    <div className="long-running-delayed-jobs-module" id="settings-light">
      {isLoading ? <LoadingAnimation /> : <EventLogsTable />}
    </div>
  );
};
